import { computed, Signal } from '@angular/core';
import { EmptyFeatureResult, SignalStoreFeature, signalStoreFeature, withComputed, withState } from '@ngrx/signals';

import { WithLoadingState } from './with-loading.interface';

interface FeatureLoading {
  state: WithLoadingState;
  props: {
    isLoading: Signal<boolean>;
  };
  methods: {};
}

export function withFeatureLoading(): SignalStoreFeature<EmptyFeatureResult, FeatureLoading> {
  return signalStoreFeature(
    withState<WithLoadingState>({ isLoadingCounter: 0 }),
    withComputed(({ isLoadingCounter }) => ({
      isLoading: computed(() => isLoadingCounter() > 0),
    })),
  );
}
